// extracted by mini-css-extract-plugin
export var statItem = "_j8-1";
export var statsRow = "_j8-0";